import { render, staticRenderFns } from "./training-section.vue?vue&type=template&id=2e769714&scoped=true"
import script from "./training-section.vue?vue&type=script&lang=ts"
export * from "./training-section.vue?vue&type=script&lang=ts"
import style0 from "./training-section.vue?vue&type=style&index=0&id=2e769714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e769714",
  null
  
)

export default component.exports